import { AxiosRequestConfig } from 'axios';
import api from './api';
import { IncidentPostRequest, IncidentPostResponsePaginated, IncidentResponsePaginated, IncidentResponse, IncidentPutRequest } from '../@types/incidentTypes';
import { mapInformationChartDataObject } from '../@types/chartData';

const samuIncidentUrl = '/api/samu_records/';

function getSamuIncidents(config: AxiosRequestConfig) {
	return api.get<IncidentResponsePaginated>(samuIncidentUrl, config);
}

function getSamuIncidentById(id: string) {
	return api.get<IncidentResponse>(`${samuIncidentUrl}${id}/`);
}

async function deleteSamuIncidentById(id: string) {
	return api.delete(`${samuIncidentUrl}${id}/`);
}

function createSamuIncident(samuIncidentData: IncidentPostRequest) {
    return api.post<IncidentPostResponsePaginated | string>(samuIncidentUrl, samuIncidentData);
}

function updateSamuIncident(id: string, updatedSamuIncidentData: IncidentPutRequest) {
	return api.put(`${samuIncidentUrl}${id}/`, updatedSamuIncidentData);
}

function getInformationChartData(config: AxiosRequestConfig) {
	return api.get<mapInformationChartDataObject[]>(`${samuIncidentUrl}map_side_list/`, config);
}

const samuIncidentServices = {
	getSamuIncidents,
	getSamuIncidentById,
	deleteSamuIncidentById,
	createSamuIncident,
	updateSamuIncident,
	getInformationChartData
};

export default samuIncidentServices;